/**
 * Run afull culling cycle for a feed using its schedule.
 */
export const feedCullSpec = {
    uri: '/t/[tenant]/feed/[feed]/cull',
    method: 'POST',
};
